/**
 * Transpose transformation for transposing chart according to center of canvas.
 */
export const Transpose = () => [
    ['transpose'],
    ['translate', 0.5, 0.5],
    ['reflect.x'],
    ['translate', -0.5, -0.5],
];
Transpose.props = { transform: true };
//# sourceMappingURL=transpose.js.map